import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic";


interface IdiomaState {
    status: string;
    error: string;
    idiomaList: any[],
    idiomaListActive: any[],
    idioma: {
        idIdioma: number | null;
        nombre: string | null;
    }

}

const initialState: IdiomaState = {
    status: 'idle',
    error: '',
    idiomaList: [],
    idiomaListActive: [],
    idioma: {
        idIdioma: null,
        nombre: null
    }
}

export const fetchIdioma = createAsyncThunk('fetchIdioma', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 55;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchIdiomaActive = createAsyncThunk('fetchIdiomaActive', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 56;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});


export const idiomaSlice = createSlice({
    name: 'idioma',
    initialState,
    reducers: {
        setIdiomaList: (state, action) => {
            state.idiomaList = action.payload;
        },
        setIdiomaListActive: (state, action) => {
            state.idiomaListActive = action.payload;
        },
        setIdioma: (state, action) => {
            state.idioma = !action.payload ? initialState.idioma : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchIdioma.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchIdioma.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.idiomaList = data ? data : [];

            })
            .addCase(fetchIdioma.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchIdiomaActive.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchIdiomaActive.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.idiomaListActive = data ? data : [];

            })
            .addCase(fetchIdiomaActive.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectIdiomaList = (state: RootState) => state.idioma.idiomaList;
export const selectIdiomaListActive = (state: RootState) => state.idioma.idiomaListActive;
export const selectIdioma = (state: RootState) => state.idioma.idioma;

export const { setIdiomaList, setIdiomaListActive, setIdioma } = idiomaSlice.actions;

export default idiomaSlice.reducer;